// extracted by mini-css-extract-plugin
export default {"card":"UserInfoCard_card__paBL0","imageAndText":"UserInfoCard_imageAndText__6R0Kp","userName":"UserInfoCard_userName__U6zJh","role":"UserInfoCard_role__vSbOd"};